<template>
  <div id="app">
    <div class="menu-box" v-if="screenWidth > 750">
      <div class="log-box">
        <!-- <img src="@/assets/logo.png" alt=""> -->
        <span> Aviral Finance Private Limited</span>
      </div>
      <div class="menu-item">
        <div @click="choiceMenu(0)" :class="(menuIndex === 0) ? 'choice' : ''">Home</div>
        <div @click="choiceMenu(1)" :class="(menuIndex === 1) ? 'choice' : ''">About Us</div>
        <div @click="choiceMenu(2)" :class="(menuIndex === 2) ? 'choice' : ''">Business</div>
        <div @click="choiceMenu(3)" :class="(menuIndex === 3) ? 'choice' : ''">Score</div>
        <div @click="choiceMenu(4)" :class="(menuIndex === 4) ? 'choice' : ''">Contact</div>
      </div>
    </div>
    <div id='step_1' ref="step_1" class="ref-home"></div>
    <div class="banner-box" id='home' ref="home">
      <!-- <img src="../assets/banner.png" class="banner"> -->
      <div class="banner-text-box">
        Kiara Microcredit Private Limited
        <p>Make finance online and simple</p>
      </div>
    </div>
    <div id='step_6' ref="step_6"></div>
    <div class="application-box">
      <div class="title">Our App</div>
      <div class="application-list">
        <a href="https://play.google.com/store/apps/details?id=com.shinning.creditstar&hl=en_IN&gl=in">
          <div class="item item-1">
            <img src="../assets/logo_1.png" alt="">
            <p>Credit Star</p>
            <div>Credit Star provides a simple and unsecured Limit Overdraft (LOC) application. We comprehensively evaluate various decision factors to carefully determine a user's credit limit, ensuring to provide the service that best suits your needs.</div>
            <a href="https://shiningcreditstar.com">learn more</a>
          </div>
        </a>
        <!-- <div class="item item-2">
          <img src="../assets/logo_2.png" alt="">
          <p>AdharLoan</p>
          <div>With this app you can easily calculate equivalent monthly installments, evaluate different loan options, perform interest rate calculations and compare two different loans. In addition, investment calculators and savings calculators provide you with critical decision support. You can even use a simple GST calculator to take better control of your finances.</div>
          <a href="https://www.keplr.app/">learn more</a>
        </div>
        <div class="item item-3">
          <img src="../assets/logo_3.png" alt="">
          <p>PoLoan </p>
          <div>EMI calculator is ideal for your loan planning and financial management. With this easy-to-use tool, you can quickly calculate your equal monthly installments (EMIs) and view a detailed payment schedule to make your repayment plan more effective.</div>
          <a href="https://dana-klik.com/">learn more</a>
        </div>  -->
      </div>
    </div>

    <div id='step_2' ref="step_2"></div>
    <div class="about-us-box">
      <img src="../assets/img-1.png" class="img-box">
      <div class="about-text">
        <div class="title">About Us</div>
        <div class="line"></div>
        <div class="text-box">
          We are a professional financial loan company dedicated to providing customers with high-quality loan products and personalized financial solutions. We adhere to the values of integrity, professionalism and innovation, provide customers with the best financial experience and service commitments, are customer-centric, and always adhere to the principles of fairness and transparency to create more financial value and opportunities for customers.
        </div>
      </div>
    </div>

    <div id='step_3' ref="step_3"></div>
    <div class="applicable-box">
      <div class="title">Our Business</div>
      <div class="line"></div>
      <div class="img-box">
        <div class="year-box">
          <img src="../assets/icon-1.png" alt="">
          <p>We provide various types of loan products, including personal loans, commercial loans, home mortgage loans, etc., to meet the diverse financial needs of customers.</p>
        </div>
        <div class="year-box">
          <img src="../assets/icon-2.png" alt="">
          <p>Our team of financial experts will provide customers with professional financial consulting services to help customers clarify financial doubts and formulate reasonable financial plans.</p>
        </div>
        <div class="year-box">
          <img src="../assets/icon-3.png" alt="">
          <p>We provide investment management services to help customers optimize their investment portfolios, achieve asset appreciation, and maximize wealth growth.</p>
        </div>
        <div class="year-box">
          <img src="../assets/icon-4.png" alt="">
          <p>We have a complete credit evaluation system that can provide customers with accurate credit evaluation reports and help customers improve their credit ratings.</p>
        </div>
      </div>
    </div>

    <div id='step_4' ref="step_4"></div>
    <div class="hear-box">
      <div class="title">User ratings and reviews</div>
      <div class="line"></div>
      <div class="juan-esteban">
        <swiper :options="pagination">
          <swiper-slide>
            <div class="swiper-1">
              <div class="swiper-title">Alexander Johnson</div>
              <div class="img-box">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
              </div>
              <div class="swiper-text">Their professional team gave me a lot of loan advice and helped me choose the best option for me. The service was top-notch and I felt truly cared for and supported.</div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="swiper-2">
              <div class="swiper-title">Liam Smith</div>
              <div class="img-box">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
              </div>
              <div class="swiper-text">I was pleasantly surprised by the fast approval process. The loan procedures were processed very quickly, which solved my problem of urgent financial needs. Really appreciate their help!</div>

            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="swiper-3">
              <div class="swiper-title">Oliver Brown</div>
              <div class="img-box">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
              </div>
              <div class="swiper-text">Their loan interest rates are indeed more attractive than other companies on the market, and they also provide very flexible repayment options, which made it easy for me to cope with financial stress.</div>

            </div>
          </swiper-slide>

          <swiper-slide>
            <div class="swiper-1">
              <div class="swiper-title">Charlotte Williams</div>
              <div class="img-box">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
              </div>
              <div class="swiper-text">The loan process was very easy and smooth, and the customer service team solved all my questions efficiently. Their wide selection of loan products allowed me to find the one that worked best for me. I am very satisfied with their service, thank you!</div>
            </div>
          </swiper-slide>

          <swiper-slide>
            <div class="swiper-1">
              <div class="swiper-title">Noah Taylor</div>
              <div class="img-box">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
              </div>
              <div class="swiper-text">I am very satisfied with the excellent service provided by their professional team and the best loan package tailored for me. The approval process was fast and the interest rate was reasonable. I was really satisfied. I would recommend their services to my friends without hesitation!</div>
            </div>
          </swiper-slide>

          <swiper-slide>
            <div class="swiper-1">
              <div class="swiper-title">Mia Rodriguez</div>
              <div class="img-box">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
                <img src="../assets/icon-5.png" alt="">
              </div>
              <div class="swiper-text">I am impressed with their customer care and can feel their sincerity and care every time I contact them. They not only provided loan services, but also gave me financial planning guidance, making me confident about the future.</div>
            </div>
          </swiper-slide>



          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>

    <div id='step_5' ref="step_5"></div>
    <div class="foot-box">
      <div class="title">Contact Us</div>
      <div class="foot-text">
        <p>Welcome to contact us! No matter you have any questions or suggestions, we are here to listen to you.</p>
        <p>Email:support@aviral-finance.com</p>
        <p>Address:Khasra No. 59/56 Near Gas Godown, Bhatagaon Raipur Raipur CT 492001 IN</p>

      </div>
      <div class="copyright">© Copyright 2024 All Rights Reserved.</div>
    </div>

  </div>
</template>

<script>
import privacy from "@/components/privacy";
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.min.css'
export default {
  name: 'App',
  components: {
    privacy,
    Swiper,
    SwiperSlide,
    directive
  },
  data() {
    return {
      isMore: false,
      menuIndex: 0,
      screenWidth: document.body.clientWidth,
      showMenu: false,
      pagination: {
        autoplay: true,
        slidesPerView: 3,
        spaceBetween: 30,
        centeredSlides: true,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          // disabledClass: 'my-button-disabled',
        },
      }
    }
  },
  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
    let item = this.$route.query.item
    console.log(item);
    if (item == 'ourapp') {
      this.$nextTick(() => {
        setTimeout(() => {
          this.choiceMenu(5)
        }, 1000);
      })
    }
  },
  methods: {
    choiceMenu(index) {
      this.menuIndex = index
      setTimeout(() => {
        this.showMenu = false
      }, 100);
      switch (index) {
        case 0: document.getElementById("step_1").scrollIntoView(); break;
        case 1: document.getElementById("step_2").scrollIntoView(); break;
        case 2: document.getElementById("step_3").scrollIntoView(); break;
        case 3: document.getElementById("step_4").scrollIntoView(); break;
        case 4: document.getElementById("step_5").scrollIntoView(); break;
        case 5: document.getElementById("step_6").scrollIntoView(); break;
        case 6: document.getElementById("step_7").scrollIntoView(); break;
        default:
          break;
      }
    },
    menuClick() {
      this.showMenu = !this.showMenu
    },
    gotoPrivacy() {
      this.$router.push({
        path: "/Privacy",
      });
    }
  }
}
</script>


<style lang="less">
@import url('@/style/m_index.less') only screen and (max-width: 750px);
@import url('@/style/pc_index.less') only screen and (min-width: 750px);
</style>
